import featureFlags from 'common/helpers/featureFlags';

export const PROJECT_SOURCE = {
  CDE: 'CDETeams',
};

export const isUMEnabled = (
  projectSource: string,
  isThirdPartyMember: boolean
) => {
  return (
    projectSource === PROJECT_SOURCE.CDE &&
    featureFlags.isUserManagementEnabled &&
    !isThirdPartyMember
  );
};
